
import React from 'react'
import { Col, Card, Button, Badge } from 'react-bootstrap'

function SmallProjectCard({
  img,
  title,
  description,
  link,
  tags = [],
  borderColor,
  index
}) {
  const handleDemoClick = () => {
    window.open(link, '_blank', 'noopener')
  }

  return (
    <Col xs={12} md={4} key={index} className="mb-4">
      <Card
        className="h-100 shadow-sm"
        style={{ borderTop: `4px solid ${borderColor}` }}
      >
        {img && (
                  <div
                    style={{
                      WebkitMask: `url(${img}) no-repeat center / contain`,
                      mask:       `url(${img}) no-repeat center / contain`,
                      backgroundColor: borderColor,
                      width:  '40px',    // adjust
                      height: '40px',    // adjust
                      margin: '15px'
                    }}
                  />
                )}

        <Card.Body className="d-flex flex-column ">
          <Card.Title as="h5" className="mb-2"
          
                style={{
                  color: borderColor,
                }}          
          
          >
            {link ? (
              <a
                href={link}
                target="_blank"
                style={{
                  color: borderColor,
                  textDecoration: 'underline'
                }}
                rel="noopener noreferrer"
              >
                {title}
              </a>
            ) : (
              title
            )}
          </Card.Title>
          <Card.Text className="flex-grow-1">{description}</Card.Text>

          {tags && tags.map && tags.length > 0 && (
            <div className="mb-3">
              {tags.map((tag, i) => (
                <Badge
                  key={i}
                  bg="light"
                  text="dark"
                  className="me-1"
                >
                  {tag}
                </Badge>
              ))}
            </div>
          )}

          {link && (
            <Button
              variant="primary"
              onClick={handleDemoClick}
              className="mt-auto align-self-start"
              size="sm"
            >
              link &rarr;
            </Button>
          )}
          {!link && (
            <Button
              variant="secondary"
              disabled
              className="mt-auto align-self-start text-muted"
              size="sm"
            >
              Coming Soon
            </Button>
          )}          
        </Card.Body>
      </Card>
    </Col>
  )
}

export default SmallProjectCard